import type { RecordSourceSelectorProxy } from 'relay-runtime';

// Event names emitted/handled by IssuePubSub
export const ISSUE_EVENT_NAMES = {
	UPDATED_OR_CREATED: 'issueUpdatedOrCreated',
	DELETED: 'issueDeleted',
} as const;

export type IssueEventNames =
	| typeof ISSUE_EVENT_NAMES.UPDATED_OR_CREATED
	| typeof ISSUE_EVENT_NAMES.DELETED;

// Payloads keyed by event name
export interface IssueEventPayloads {
	issueUpdatedOrCreated: { resourceId: string };
	issueDeleted: { resourceId: string; store: RecordSourceSelectorProxy };
}

// Public API shape for strongly-typed pub-sub
export type IssueEventsApi = {
	subscribe<K extends IssueEventNames>(
		event: K,
		subscriber: (payload: IssueEventPayloads[K]) => void,
	): () => void;
	unsubscribe<K extends IssueEventNames>(
		event: K,
		subscriber: (payload: IssueEventPayloads[K]) => void,
	): void;
	publish<K extends IssueEventNames>(event: K, payload: IssueEventPayloads[K]): void;
};
